import { FinPropostaStatus, FinPropostaTipoCriacao } from './enum';
import { Financiadora } from './financiamento/financiadora';

export class FinProposta {
  id: number;
  idVinculo: number;
  idOctopus: string;
  status: FinPropostaStatus;
  statusDescricao: string;
  visivel: boolean;
  valorParcela: number;
  txJuros: number;
  qtdParcelas: number;
  titulo: string;
  descricao: string;
  carencia: number;
  totalEmprestimo: number;
  totalJuros: number;
  totalTarifas: number;
  txJurosPercMensal: number;
  txJurosPercAnual: number;
  cetAnual: number;
  cetMensal: number;
  dtStatus: Date;
  dtCriacao: Date;
  valorLiberado: number;
  dtVencimento: Date;
  simulacaoExpirada: boolean;
  tipoAnaliseIntegrador: number;
  dtEscolha: Date;
  nomeSolicitante: string;
  nomeIntegrador: string;
  idCupom: string;
  originacaoSchema: string;
  originacaoModel: string;
  actionSchemaId: string;
  msgStatus: string;
  idSimulacao: number;
  proponente: string;
  tipoCriacao: FinPropostaTipoCriacao;
  valorEntrada?: number | null;
  dtPrimeiraParcela?: Date | null;
  idFormulario?: number | null;
  valorSolicitado?: number | null;
  comSeguro?: boolean | null;

  // virtuais
  financiadora: Financiadora;
  imagem$: any;
  semImagem: boolean;
  buscouImagem: boolean;
  buscouEtapaOportunidade: boolean;
  etapaOportunidade?: string | null;
  idFinanciadora: number;
}
